<template>
	<div class="main-view">
		<div style="margin-bottom: 10px;
					display: flex;
					flex-direction: row;
					align-items: center;">
			<!-- <span style="color: #FF8826;">1</span>-->
			<div style="font-size: 14px;
						width: 6px;
						height: 15px;
						background-color: #409eff;
						margin-right: 5px;
						border-radius: 4px;"></div> 
			<span style="margin-left: 0px;">{{ cardTitle }}（共{{  questionArr.length}}题）</span>
		</div>
		<div class="quetion-item" v-for="item,index in questionArr" :key="index"  :id="item.id">
			<div class="title-topic">
				
				<div class="label">
					{{item.text}}【{{ SUB_DRILL_TYPE[item.subType].label }}】
				</div>
				<audio
					class="aud"
					:ref="`${item.id}`"
					@play="onPlay(item)"
					@pause="onPause(item)"
					:src="item.audioUrl"
					controls="controls"
					style="width:70%;"
					v-if="item.audioUrl != null"
					>
				</audio>
				<img style="width: 50%;" mode="aspectFit" :src="item.imageUrl" v-if="item.imageUrl != null"/>
			</div>

			<div v-if="item.subType==401 || item.subType==402 || item.subType==403">

			</div>


			<div  v-if="item.subType==601 || item.subType==602">
				<div class="question-list-view" v-for="questionItem,questionIndex in item.questionList" :key="questionIndex">
					<div class="question-text">
						<div class="label">
							{{questionItem.text}}
						</div>
						<img style="width: 50%;" mode="aspectFit" :src="questionItem.imageUrl" v-if="questionItem.imageUrl != null"/>
					</div>

					<div class="question-view" v-if="item.subType==102">
						<el-checkbox-group v-model="checkList">
							<el-checkbox :label="`${option.id}.${option.text}`" class="el-checkbox" v-for="option,opIndex in questionItem.optionList" :key="opIndex" >
								<el-image :src="option.imageUrl" class="option-img" v-if="option.imageUrl != null"></el-image>
							</el-checkbox>
							<!-- <el-checkbox label="复选框 B" class="el-checkbox"></el-checkbox>
							<el-checkbox label="复选框 C" class="el-checkbox"></el-checkbox>
							<el-checkbox label="复选框 D" class="el-checkbox"></el-checkbox> -->
						</el-checkbox-group>
					</div>
					<div class="question-view" v-if="(item.subType==101 || item.subType==103)">
						
						<el-radio-group v-model="checkList">
							<el-radio :label="`${option.id}.${option.text}`"  class="el-radio" v-for="option,opIndex in questionItem.optionList" :key="opIndex">
								<el-image :src="option.imageUrl" class="option-img" v-if="option.imageUrl != null"></el-image>
							</el-radio>
						</el-radio-group>
					</div>
					<div class="question-view" v-if="(item.subType==601 || item.subType==602)">
						<el-radio-group v-model="checkList">
							<el-radio :label="`${option.id}.${option.text}`"  class="el-radio" v-for="option,opIndex in questionItem.optionList" :key="opIndex">
								<el-image :src="option.imageUrl" class="option-img" v-if="option.imageUrl != null"></el-image>
							</el-radio>
						</el-radio-group>
					</div>
					<div v-if="showAnswerFlagD" class="correctAnswer-view">正确答案：{{ questionItem.correctAnswer.join('，') }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { SUB_DRILL_TYPE } from "@/utils/constant.js";
import PassageChoiceDrillApi from '@/api/src/drill/api/PassageChoiceDrillApi'
const passageChoiceDrillApi = new PassageChoiceDrillApi()

export default {
	props:['showAnswerFlag','questionData','cardTitle'],
	data(){
		return{
			section:null,
			checkList: [],
			radio: 3,
			showAnswerFlagD:this.showAnswerFlag,
			questionDataArr:this.questionData,
			questionArr:[],
			SUB_DRILL_TYPE: SUB_DRILL_TYPE,
		}
	},
	mounted () {
		this.loadData()
	},
	watch:{
		
		showAnswerFlag(val){
			console.log("监听到变化")
			this.showAnswerFlagD = val
			this.$forceUpdate()
			//如果showAnswerFlagD为true，则清空this.checkList  如果shiwAnswerFlagD为false，则清空this.checkList
			// if(val){
			// 	this.checkList = ["复选框 A","复选框 C"]
			// }else{
			// 	this.checkList = []
			// }
		},
		// questionData(val){
		// 	console.log("监听到变化")
		// 	console.log(val)
		// 	this.section = val
		// }
	},
	methods:{
		radioChange(index,value){

		},
		async loadData(){
			let drillIds = this.questionDataArr.map(item => {return item.drillId})
			var body = {
				sessionTime: 0,
				idList: drillIds
			}
			var resp = await passageChoiceDrillApi.getDrillList(body)
			console.log('----loadData---')
			console.log(resp)
			
			

			this.questionArr = resp


			console.log(this.checkListMap)
		},
		getCorrectAnswer(item,option){
			console.log("getCorrectAnswer")
			var value = false
			if(this.showAnswerFlagD == true){
				value = option.correctAnswer
			}else{
				value = false
			}
			console.log(value)
			return this.showAnswerFlagD
		},

		onPlay(item) {
			item.status = 'play';
			// console.log(this.$refs)
			for (let i = 0; i < this.questionArr.length; i++) {
				
				if (item.id != this.questionArr[i].id) {
					// 不是当前需播放的音频
					let id = this.questionArr[i].id;
					this.$refs[id][0].pause();
					console.log(this.$refs)
				} else {
					// 是当前需要播放的音频
				}
			}
		},

		/**
		 * 当音频暂停
		 */
		onPause(item) {
			item.status = 'pause';
		}
	}
}
</script>

<style lang="less" scoped>
	.main-view{
		margin: 10px;
		border-radius: 10px; /* 圆角半径10px */
		box-shadow: 0 0 10px rgba(132, 132, 132, 0.3); /* 添加阴影效果 */
		padding: 20px; /* 内边距 */
		width: 87%;
		padding-bottom: 0px;
	}

	.quetion-item{
		display: flex;
		flex-direction: column;
		border-bottom: 2px solid #dddddd;
		margin-top: 10px;
		.title-topic{
			font-size: 18px;
			margin-left: 10px;
			display: flex;
			flex-direction: column;
			.label{
				font-size: 17px;
				line-height: 24px;
			}
		}
		.question-view{
			margin-top: 10px;
			margin-bottom: 10px;
			margin-left: 20px;
		}
	}

	.el-checkbox {
		display: flex; 
		padding-top: 10px;
		flex-basis: 100%; 
		align-items: center;
	}
	.option-img{
		width: 100px;
		height: 100px;
	}
	.el-radio{
		display: flex; 
		padding-top: 10px;
		flex-basis: 100%; 
		align-items: center;
		/deep/ .el-radio__label{

			font-size:16px !important;
			
		}
	}
	.correctAnswer-view{
	    margin: 20px;
		margin-top: 10px;
		color: green;
	}

	.question-list-view{
		display: flex;
		flex-direction: column;
		margin-top: 18px;
		margin-left: 20px;
		.label{
			font-size: 17px;
			line-height: 24px;
		}
		.question-text{
			font-size: 20px;
			display: flex;
			flex-direction: column;
		}
	}

	.aud{
		margin-top: 10px;
	}


	el-radio{
		display: flex;
	}
	
	el-checkbox{
		display: flex;
	}
	

	/deep/ .el-radio__label{
		white-space: normal;  /* 换行 */
		line-height: 30px;
	}
	
	/deep/ .el-checkbox__label{
		white-space: normal;  /* 换行 */
	}
	/deep/ .el-radio__input{
		white-space: normal;  /* 换行 */
		padding-top: 8px;
	}

	/deep/ .el-radio{
		align-items: baseline;
	}

	

	
</style>